import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { Link } from 'react-router-dom';
import { useL10n } from '@uplift/hooks';
import { Button, StackableCard } from '@uplift/ui-v2';

import EventBusyIcon from '@mui/icons-material/EventBusy';

import { ScheduleModals } from '../../../../components';
import { useCurrentuser } from '@uplift/contexts';
import { ROUTING_CONFIG } from '@uplift/constants';


const NoUpcomingSessionsAndTherapistMessage: React.VFC = () => {
  const l10n = useL10n();

  return (
    <>
      <Box mb={3}>
        <Typography variant="body1" color="textSecondary">
          {l10n.noSessionsScheduledForToday.scheduleDetails1}
        </Typography>
      </Box>
      <Box mb={1}>
        <Button component={Link} to={ROUTING_CONFIG.matching} variant="contained" color="secondary">
          {l10n.noSessionsScheduledForToday.findATherapist}
        </Button>
      </Box>
      <Typography variant="body2" color="textSecondary">
        {l10n.noSessionsScheduledForToday.scheduleDetails2}
      </Typography>
    </>
  );
};


const NoUpcomingSessionsMessage: React.VFC = () => {
  const l10n = useL10n();

  return (
    <Typography variant="body1" color="textSecondary">
      {l10n.noSessionsScheduledForToday.emailYourProvider}
    </Typography>
  );
};


const useStyles = makeStyles()(theme => ({
  wrapper: {
    whiteSpace: 'initial',
    textAlign: 'center',
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      whiteSpace: 'pre-wrap',
    }
  }
}));

export type NoUpcomingSessionsProps = {
  needToMatchTherapist?: boolean;
};

export const NoUpcomingSessions: React.VFC<NoUpcomingSessionsProps> = ({ needToMatchTherapist }) => {
  const l10n = useL10n();
  const { classes } = useStyles();
  const user = useCurrentuser();

  return (
    <div>
      <StackableCard className={classes.wrapper}>
        <Box color="#D5D2C7" fontSize="60px">
          <EventBusyIcon fontSize="inherit" />
        </Box>
        <Box mb={1}>
          <Typography variant="h6" color="textSecondary">
            {l10n.noSessionsScheduledForToday.noUpcomingSessions}
          </Typography>
        </Box>
        {needToMatchTherapist
          ? <NoUpcomingSessionsAndTherapistMessage />
          : <NoUpcomingSessionsMessage />
        }
        <ScheduleModals patientId={user.id} />
      </StackableCard>
    </div>
  );
};
